import { Flex, Tag } from "antd";
import React from "react";
import { capitalize } from "../../utilities/utils";

const CustomHeader = ({ title, leftSide, rightSide, visibility, status }) => {
  return (
    <Flex
      align="flex-start"
      justify="space-between"
      style={{ minHeight: "50px", marginBottom: "10px" }}
    >
      <Flex vertical gap={"10px"}>
        <Flex>
          {visibility && (
            <Tag
              style={{
                borderStyle: "dashed",
                borderRadius: "8px",
                padding: "0 15px",
              }}
              color={visibility === "public" ? "green" : "default"}
            >
              {capitalize(visibility === "public" ? "нийтлэгдсэн" : "ноорог")}
            </Tag>
          )}
          {status && (
            <Tag
              style={{
                borderStyle: "dashed",
                borderRadius: "8px",
                padding: "0 15px",
              }}
              color={
                status === "completed"
                  ? "green"
                  : status === "ongoing"
                  ? "blue"
                  : "orange"
              }
            >
              {capitalize(
                status === "completed"
                  ? "дууссан"
                  : status === "ongoing"
                  ? "эхэлсэн"
                  : "удахгүй болох"
              )}
            </Tag>
          )}
        </Flex>
        <h2 style={{ margin: 0 }}>{title}</h2>
        {leftSide}
      </Flex>
      {rightSide}
    </Flex>
  );
};

export default CustomHeader;
